import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, RouterEvent, NavigationStart, NavigationEnd, ActivatedRoute, UrlSegment } from '@angular/router';
import { FormValuesService } from './services/form-values/form-values.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdvisorModalComponent } from './advisor-modal/advisor-modal.component';

export enum linksNoSubNav {
  kundenuebersicht  = "/kundenuebersicht",
  kundenbearbeitung = "/kundenbearbeitung"
}; 

enum MODAL{
  seen = "modalSeen"
}

interface Links {
  address: string;
  title: string;
  iconActive?: string;
  iconNotActive?: string;
  iconDisabled?: string;
  showLinks?: boolean;
  highlight?: boolean;
  links?: Array<Links>;
  disabled?: boolean;
};


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {

  public title: string = "?????";
  public mainLinks: Array<Links> = null;
  public hideSubMenu: boolean = false;

  private mainLinksClean: Array<Links> = [
    {
      address: "/eingaben",
      title: "Eingabe",
      iconActive: "assets/img/svg/eingabeActive.svg",
      iconNotActive: "assets/img/svg/eingabeNotActive.svg",
      showLinks: false,
      highlight: false,

      links: [
        {
          address: "/eingaben/daten",
          title: "Persönliche Daten",
          showLinks: false,
          highlight: false,
        },
        {
          address: "/eingaben/finanzen",
          title: "Finanzen",
          showLinks: false,
          highlight: false,
        },
        {
          address: "/eingaben/versorgung",
          title: "Versorgung",
          showLinks: false,
          highlight: false,
        },
        /*
        {
          address: "/eingaben/weiteres",
          title: "Weiteres",
          showLinks: false,
          highlight: false,
        },
        */
      ]
    },
    {
      address: "/auswertung",
      title: "Auswertung",
      iconActive: "assets/img/svg/auswertungActive.svg",
      iconNotActive: "assets/img/svg/auswertungNotActive.svg",
      iconDisabled: "assets/img/svg/auswertung_disabled.svg",
      showLinks: false,
      highlight: false,

      links: [
        {
          address: "/auswertung/uebersicht",
          title: "Übersicht",
          showLinks: false,
          highlight: false,
        },
        {
          address: "/auswertung/krankheit",
          title: "Krankheit",
          showLinks: false,
          highlight: false,
        },
        {
          address: "/auswertung/unfall",
          title: "Unfall",
          showLinks: false,
          highlight: false,
        },
        {
          address: "/auswertung/em_bu",
          title: "EM / BU",
          showLinks: false,
          highlight: false,
        },
        {
          address: "/auswertung/alter",
          title: "Alter",
          showLinks: false,
          highlight: false,
        },
        {
          address: "/auswertung/pflege",
          title: "Pflege",
          showLinks: false,
          highlight: false,
        },
      ]
    },
  /*
    {
      address: "/test",
      title: "Testseite",
      iconActive: "assets/img/svg/eingabeActive.svg",
      iconNotActive: "assets/img/svg/eingabeNotActive.svg",
      showLinks: false,
      highlight: false,
    },
  */
  ];
  
  private linksNoSubNavArray: Array<Links> = [
    {
      address:  linksNoSubNav.kundenbearbeitung,
      title:    "Kundenbearbeitung"
    },
    {
      address:  linksNoSubNav.kundenuebersicht,
      title:    "Kundenübersicht"
    }
  ]; 
  
  public collapsed: boolean = true;

  public toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formValueService: FormValuesService,
    private modalService: NgbModal,
  ) {    
    router.events.subscribe((event: RouterEvent) => {
      
      this.hideSubMenuCheck(); 
      
      if (event instanceof NavigationEnd) {
        let mainLinksTmp: Array<Links & { urlSegments: Array<UrlSegment> }> = JSON.parse(JSON.stringify(this.mainLinksClean));
        let tmp = this.route;

        while (tmp.firstChild) tmp = tmp.firstChild;

        mainLinksTmp[1].disabled = !this.formValueService.hasValue('auswertung');

        tmp.url.subscribe((currentUrlSegments: Array<UrlSegment>) => {
          mainLinksTmp.forEach((mainLink, mainLinkKey) => {
            mainLink.urlSegments = router.parseUrl(mainLink.address).root.children['primary'].segments;

            if (mainLink.urlSegments[0].path === currentUrlSegments[0].path) {
              mainLinksTmp[mainLinkKey].highlight = true;
              mainLinksTmp[mainLinkKey].showLinks = true;
            }

            if (mainLink.links) {
              mainLink.links.forEach((subLink, subLinkKey) => {
                if (subLink.address === router.url) {
                  mainLinksTmp[mainLinkKey].links[subLinkKey].highlight = true;
                  this.title = subLink.title;
                }
              });
            }
          });
        });
        this.mainLinks = mainLinksTmp;
      }
    });

    if( !this.formValueService.getValue(MODAL.seen) ){
      this.openModal();  
    }
    
  }

  openModal() {
    const seen: string = MODAL.seen;
    this.modalService.open(AdvisorModalComponent, { size: 'lg', backdrop: 'static', keyboard: false })
    .result
    .then((result)=>{
    },(showNoMore)=>{
      if(showNoMore){
        this.formValueService.setValue(seen,true);
      }
    });
  }
  
  private hideSubMenuCheck(){
    this.hideSubMenu = false;
    
    this.linksNoSubNavArray.forEach(link => {
      if(
        link.address === this.router.url.substring(0,link.address.length)
      ){
        this.hideSubMenu = true;
        this.title = link.title;
      } 
    });    
  }

}


// WEBPACK FOOTER //
// ./src/app/app.component.ts